import { Extension } from "@tiptap/core";
import { CoreExtensionNames } from "../../constants/extention";
import { handleBackspace, handleDelete } from "./list-helpers";
import { getErrorMessage } from "utils/error";
import { toast } from "react-toastify";

type ListKeymapOptions = {
  listTypes: Array<{
    itemName: string;
    wrapperNames: string[];
  }>;
};

export const ListKeymap = ({ tabIndex }: { tabIndex?: number } = {}) =>
  Extension.create<ListKeymapOptions>({
    name: "listKeymap",

    addOptions() {
      return {
        listTypes: [
          {
            itemName: CoreExtensionNames.LIST_ITEM,
            wrapperNames: [
              CoreExtensionNames.BULLET_LIST,
              CoreExtensionNames.ORDERED_LIST
            ]
          }
        ]
      };
    },

    addKeyboardShortcuts() {
      return {
        Tab: () => {
          const isListItem = this.editor.isActive(CoreExtensionNames.LIST_ITEM);
          const hasTabIndex = tabIndex != null;
          return (
            (isListItem &&
              this.editor.commands.sinkListItem(
                CoreExtensionNames.LIST_ITEM
              )) ||
            !hasTabIndex
          );
        },
        "Shift-Tab": () => {
          const hasTabIndex = tabIndex != null;

          return (
            this.editor.commands.liftListItem(CoreExtensionNames.LIST_ITEM) ||
            !hasTabIndex
          );
        },
        Delete: ({ editor }) => {
          try {
            let handled = false;

            this.options.listTypes.forEach(({ itemName }) => {
              if (handleDelete(editor, itemName)) handled = true;
            });

            return handled;
          } catch (error) {
            console.error("Error in handling Delete:", error);
            return false;
          }
        },
        "Mod-Delete": ({ editor }) => {
          try {
            let handled = false;

            this.options.listTypes.forEach(({ itemName }) => {
              if (handleDelete(editor, itemName)) handled = true;
            });

            return handled;
          } catch (error) {
            const message = getErrorMessage(error);
            toast.error(message);
            return false;
          }
        },
        Backspace: ({ editor }) => {
          try {
            let handled = false;

            this.options.listTypes.forEach(({ itemName, wrapperNames }) => {
              if (handleBackspace(editor, itemName, wrapperNames))
                handled = true;
            });

            return handled;
          } catch (error) {
            const message = getErrorMessage(error);
            toast.error(message);
            return false;
          }
        },
        "Mod-Backspace": ({ editor }) => {
          try {
            let handled = false;

            this.options.listTypes.forEach(({ itemName, wrapperNames }) => {
              if (handleBackspace(editor, itemName, wrapperNames))
                handled = true;
            });

            return handled;
          } catch (error) {
            const message = getErrorMessage(error);
            toast.error(message);
            return false;
          }
        }
      };
    }
  });
